import { render } from "./Earth.vue?vue&type=template&id=0bde9d7e"
import script from "./Earth.vue?vue&type=script&lang=js"
export * from "./Earth.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Earth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bde9d7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bde9d7e', __exports__)) {
    api.reload('0bde9d7e', __exports__)
  }
  
  module.hot.accept("./Earth.vue?vue&type=template&id=0bde9d7e", () => {
    api.rerender('0bde9d7e', render)
  })

}


export default __exports__